import { Input } from 'antd';
import { LabeledToggle, LabelPlacement, Row } from '@ydistri/ds';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import AdministrationFiltersPanel from '../../../common/AdministrationFiltersPanel';
import ShowArchivedItemsToggle from '../../../common/ShowArchivedItemsToggle';
import SortSelector from '../../../common/SortSelector';
import type { ScopeCatalogSortField } from '../scopeCatalogFilters';

const ScopeSearch = styled(Input.Search)`
  width: 100%;
`;

interface ScopesFiltersProps {
  archivedItemsCount: number;
  search: string;
  showArchivedItems: boolean;
  showLocalItems: boolean;
  sortField: ScopeCatalogSortField;
  onSearchChange: (search: string) => void;
  onShowArchivedItemsChange: (showArchivedItems: boolean) => void;
  onShowLocalItemsChange: (showLocalItems: boolean) => void;
  onSortChange: (sortField: ScopeCatalogSortField) => void;
}

const ScopesFilters: React.FC<ScopesFiltersProps> = ({
  archivedItemsCount,
  search,
  showArchivedItems,
  showLocalItems,
  sortField,
  onSearchChange,
  onShowArchivedItemsChange,
  onShowLocalItemsChange,
  onSortChange,
}) => {
  const changeSortField = useCallback(
    (value: string) => {
      if (value === 'LastUpdatedAt' || value === 'Name') onSortChange(value);
    },
    [onSortChange],
  );

  return (
    <AdministrationFiltersPanel>
      <ScopeSearch
        allowClear
        aria-label="Search Scopes"
        placeholder="Search Scopes"
        value={search}
        onChange={event => onSearchChange(event.target.value)}
      />
      <Row data-testid="ScopeVisibilityToggles" $flexWrap="nowrap" $gap="0.5rem">
        <LabeledToggle
          checked={showLocalItems}
          id="ShowLocalScopesToggle"
          label="Show local"
          labelPlacement={LabelPlacement.LEFT}
          margin="0"
          onClick={() => onShowLocalItemsChange(!showLocalItems)}
        />
        <ShowArchivedItemsToggle
          archivedItemsCount={archivedItemsCount}
          checked={showArchivedItems}
          onClick={() => onShowArchivedItemsChange(!showArchivedItems)}
        />
      </Row>
      <SortSelector defaultValue={sortField} onSortChange={changeSortField} />
    </AdministrationFiltersPanel>
  );
};

export default ScopesFilters;
